<template>
  <div class="online-cv-wrapper" :style="iosOrAndroidStyle">
    <w-nav-bar @mobileLeftBtn="routerBack" v-show="iosOrAndroidShow"/>
    <div class="online-header">
      <p class="headline title">请补充基本信息</p>
    </div>
    <div class="form-list">
      <w-form :form-list="baseInfoData" :form-data="formData" @handleClick="editFormItem">
        <div slot="contact" class="contact">{{ formData.contact }}</div>
        <div class="flex-column" slot="edu" v-if="!onlineCvValid.edu_valid && formData.edu">
          <div class="flex-between content-top">
            <span>{{ eduInfo.university }}</span>
            <span class="time">{{ eduInfo.start_at | timeFilter('YYYY.MM') }}-{{ eduInfo.end_at | timeFilter('YYYY.MM') }}</span>
          </div>
          <div class="content-bottom">
            <span>{{ eduInfo.degree }}</span>
            <span>{{ eduInfo.major }}</span>
          </div>
        </div>
        <div class="flex-column" slot="work" v-if="!onlineCvValid.work_valid && formData.work">
          <div class="flex-between content-top">
            <span>{{ workInfo.company }}</span>
            <span class="time">{{ workInfo.start_at | timeFilter('YYYY.MM') }}-{{ (workInfo.end_at && timeReplace(workInfo.end_at)) || workInfo.present }}</span>
          </div>
          <div class="content-bottom">
            <span>{{ workInfo.title }}</span>
          </div>
        </div>
      </w-form>
    </div>
    <div class="online-footer footer">
      <button class="theme-button flex-center footer-button" :class="{'disable-button': disableState}"
              @click="nextStep">下一步
      </button>
    </div>
  </div>
</template>

<script>
	import WNavBar from '@/components/global/w-navbar'
	import WForm from '@/components/global/w-form'
	import { baseInfo } from '@/assets/json/online-cv'
	import { verifyRequired } from '@/assets/js/utils'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { envMixin } from '@/assets/js/mixin/global'
	import { eventMixin } from '@/assets/js/mixin/global'

	import { mapActions, mapState, mapGetters } from 'vuex'
	import Cookies from 'js-cookie'

	let moment = require('moment')

	export default {
		name: 'online-base-info',
		mixins: [ envMixin, componentsMixin, eventMixin ],
		data () {
			return {
				baseInfo,
				requiredEdu: [ 'university', 'major', 'degree', 'start_at', 'end_at' ],
				requiredWork: [ 'company', 'title', 'start_at', [ 'end_at', 'present' ] ],
				formData: {
					name: '',
					gender: '',
					contact: '',
					edu: false,
					work: false,
				}
			}
		},
		async mounted () {
			// await this.iosBridgeGet()
			await this.getBasicData()
			this._getCvData()
			console.log(this.eduInfo)
		},
		computed: {
			...mapState('cv', [ 'onlineCvBasic', 'onlineCvValid', 'cv' ]),
			...mapGetters('cv', [ 'eduFullInfo', 'workFullInfo' ]),
			token () {
				return this.$route.params.online_token
			},
			// 基本信息
			baseInfoData () {
				if (this.onlineCvValid) {
					return this.baseInfo.filter(item => {
						if (item.show || !this.onlineCvValid[item.validField]) {
							return item
						}
					})
				}
			},
			// 教育信息
			eduInfo () {
				return this.eduFullInfo && this.eduFullInfo.length && this.eduFullInfo[0] || {}
			},
			// 工作信息
			workInfo () {
				return this.workFullInfo && this.workFullInfo.length && this.workFullInfo[0] || {}
			},
			// 保存时的校验
			requiredField () {
				return [
					{ val: this.formData.name, message: '请填写姓名' },
					{ val: this.formData.gender, message: '请选择性别' },
					{ val: this.formData.contact, message: '请填写联系方式' },
					{ val: this.formData.edu || this.onlineCvValid.edu_valid, message: '请填写教育经历' },
					{ val: this.formData.work || this.onlineCvValid.work_valid, message: '请填写工作经历' }
				]
			},
			// 底部按钮的禁用标识
			disableState () {
				return verifyRequired(this.requiredField)
			},
			cvAccountToken () {
				let _t = Cookies.get('_t')
				let tokenPayload = JSON.parse(window.atob(_t.split('.')[1]))
				return tokenPayload.User.c_t
			},
		},
		watch: {},
		components: {
			WNavBar,
			WForm
		},
		methods: {
			...mapActions('cv', [ 'getOnlineCvBasic', 'getCvDetail', 'getModuleInfo' ]),
			timeReplace (val) {
				return moment(val).format('YYYY.MM')
				// return val.replace(/-/g, '.')
			},
			// 编辑信息点击事件
			editFormItem (item) {
				if (item.type === 'picker') {
					const pickerData = [ { text: '男', value: '男' }, { text: '女', value: '女' } ]
					const index = this.formData.gender ? pickerData.findIndex(v => v.value === this.formData.gender) : 0
					this.$createPicker({
						data: [ pickerData ],
						selectedIndex: [ index ],
						onSelect: (val) => {
							this.formData.gender = val.join()
							this.onlineCvBasic.gender = val.join()
						}
					}).show()
				} else if (item.type === 'router') {
					this.onlineCvBasic.name = this.formData.name
					this.iosBridgeSave()
					this.routeTo(`/cvs/online/${ this.token }/${ item.path }`)
				}
			},
			// 获取到简历数据
			async _getCvData () {
				await this.getCvDetail({ token: this.token })
				let { submodule_info: { edus_ids, works_ids }, basic_info: { lang } } = this.cv
				let edu_id = null, work_id = null
				if (edus_ids.length) edu_id = edus_ids[0]
				if (works_ids.length) work_id = works_ids[0]
				if (edu_id) await this.getModuleInfo({
					payload: { lang, ids: edu_id },
					moduleName: 'edus'
				})
				if (work_id) await this.getModuleInfo({
					payload: { lang, ids: work_id },
					moduleName: 'works'
				})
				// await Promise.all([ this.getModuleInfo({}), this.getModuleInfo() ])
				this._dealInfo()
			},
			// 获取基本信息
			async getBasicData () {
				if (this.onlineCvBasic && !Object.keys(this.onlineCvBasic).length) {
					await this.getOnlineCvBasic(this.token)
				}
				this.formData = { ...this.formData, ...this.onlineCvBasic }
			},
			// 点击下一步
			async nextStep () {
				if (verifyRequired(this.requiredField)) {
					this.showToast(verifyRequired(this.requiredField), 2000)
					return
				}
				let payload = JSON.parse(JSON.stringify(this.formData))
				delete payload.edu
				delete payload.work
				let res = await this.$api.online.createBasicInfo(payload, this.cvAccountToken)
				if (res.code === 1000) {
					try {
						let res = await this.$api.online.createOnlineCv({ token: this.token })
						if (res.code === 1000) {
							this.$router.push(`/cvs/online/${ this.token }/preview`)
						}
					} catch (error) {
						console.log(error)
					}
				}
			},
			// 处理是否显示
			_dealInfo () {
				if (!this.verifyEmpty(this.requiredEdu, this.eduInfo) && !this.onlineCvValid.edu_valid) this.formData.edu = true
				if (!this.verifyEmpty(this.requiredWork, this.workInfo) && !this.onlineCvValid.work_valid) this.formData.work = true
			},
			// 校验教育和工作信息
			verifyEmpty (fields, info) {
				for (let i = 0; i < fields.length; i++) {
					if (fields[i] instanceof Array) {
						if (!info[fields[i][0]] && !info[fields[i][1]]) return true
					} else {
						if (!info[fields[i]]) return true
					}
				}
			},
			routerBack () {
				this.$router.back()
			}
		},
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/cv/online-cv';
  .form-list {
    padding: 0 24px;
    /deep/ .contact {
      font-size: $font-size-medium-x;
      color: $color-title;
      line-height: 22px;
    }
  }

  .content-top {
    width: calc(100vw - 74px);
    margin-bottom: 6px;
    span {
      color: $color-title;
      font-size: $font-size-medium-x;
      line-height: 20px;
      white-space: nowrap;
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .time {
      color: #9C9C9C;
      font-size: $font-size-medium;
    }
  }
  .content-bottom {
    span {
      color: #9C9C9C;
      font-size: $font-size-medium;
      line-height: 22px;
      &::after {
        content: '|';
        margin: 0 6px;
      }
      &:last-child::after {
        content: '';
      }
    }
  }
</style>
